if (fb_app_id.length != 0) {
  document.writeln("<div id=\"fb-root\"><script type=\"text/javascript\" src=\"" + document.location.protocol + "//connect.facebook.net/en_US/all.js\"></script></div>");
}

jQuery.fn.facebookExecute = function(settings) {
  var el = jQuery(this[0]);
  var func = el.data("facebookExecute");
  if(func !== undefined && func != null) func(settings);
};

$(function() {
  if (fb_app_id.length == 0) {
    jQuery(".wp-fb_login_btn").hide();
    return;
  }

  var facebookPermissions = "";
  var on_access_granted_callbacks = [];

  function fb_requestPermissions(requestedPermissions) {
    if(requestedPermissions == undefined || requestedPermissions == null || requestedPermissions == "") {
      requestedPermissions = "email,user_birthday,user_about_me,user_photos";
    }
    FB.login(function(response) {
      if(response.session && response.perms) {
        for(var i=0; i<on_access_granted_callbacks.length; i++) {
          on_access_granted_callbacks[i]();
        }
      }
    }, {perms:requestedPermissions});
  }

  function fb_addAccessGrantedCallback(callback) {
    for(var i=0; i<on_access_granted_callbacks.length; i++) {
      if(on_access_granted_callbacks[i] == callback) return;
    }
    on_access_granted_callbacks[on_access_granted_callbacks.length] = callback;
  }

  jQuery(".wp-fb_login_btn").show();
  
  FB.init({
    "appId": fb_app_id,
    "status" : true, // check login status
    "cookie" : true, // enable cookies to allow the server to access the session
    "xfbml"  : true  // parse XFBML
  });

  jQuery(".fb-publish").each(function() {
    var el = jQuery(this);
    var messageText = el.text();
    el.data("facebookExecute", function() {
      (function(queryPermissions, callback) {
        var checkPermissionsAndExecute = arguments.callee;
        FB.api(
          {"method": "users.hasAppPermission", "ext_perm": "publish_stream"},
          function(response) {
            if(response == 1) {
              callback();
            } else {
              fb_addAccessGrantedCallback(callback);
              if(queryPermissions) fb_requestPermissions("publish_stream");
            }
          }
        );
      })(
        false,
        function() {
          FB.api("/me/feed", "post", {"message": messageText});
        }
      );
    });
    if(el.attr("execute-on-load") == "1") (el.data("facebookExecute"))();
  });

});